import theme from "@ticketingplatform/ui/dist/theme";

export const defaultTheme = theme;
